import React, { Component } from 'react';
import GlobalContext, { Redirects } from './GlobalContext';
import FirebaseDB from './firebase';

class QuoteRequestForm extends Component {
    constructor(props) {
        super(props);
        this.handleFname = this.handleFname.bind(this);
        this.handleLname = this.handleLname.bind(this);
        this.handleMsg = this.handleMsg.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handlePhone = this.handlePhone.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = { src: props.source.href, sendOffers: true };
        console.log(this.state);
    }

    validateForm() {
        this.setState({ validationError: null })
        console.log(this.state.fName);
        if (!this.state.fName || this.state.fName === "") {
            this.setState({ validationError: "First Name Cannot be blank!" })
            return false;
        }
        if (!this.state.lName || this.state.lName === "") {
            this.setState({ validationError: "Last Name Cannot be blank!" })
            return false;
        }
        if (this.state.email && this.state.email !== "") {

            const valid = this.validateEmail();
            console.log("valid? " + valid);
            if (!valid) {
                this.setState({ validationError: "Invalid Email Address!" })
                return false;
            }
        }
        else {
            this.setState({ validationError: "Invalid Email Address!" })
            return false;
        }

        return true;
    };

    validateEmail() {
        const emailRegex = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/gi;
        return emailRegex.test(this.state.email);
    }

    handleFname(event) { this.setState({ fName: event.target.value }); }
    handleLname(event) { this.setState({ lName: event.target.value }); }
    handleMsg(event) { this.setState({ msg: event.target.value }); }
    handleEmail(event) { this.setState({ email: event.target.value }); }
    handlePhone(event) { this.setState({ phone: event.target.value }); }
    handleCheck(event) {
        console.log("on check");
        console.log(event.target.checked);
        this.setState({ sendOffers: event.target.checked });
    }

    handleSubmit(event) {
        console.log("submit");
        console.log(JSON.stringify(this.state));
        event.preventDefault();

        const valid = this.validateForm();
        console.log(valid);
        if (valid) {

            const db = new FirebaseDB("quote request");
            const r = db.upload("NewQuoteRequests", this.state, this.gotoResult);

            // fetch('http://www.signsandimpressions.com/quoterequest', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify(this.state)
            // })
            //     .then(response => response.json())
            //     .then(data => this.gotoResult(data.result)).
            //     catch(() => { this.gotoResult(0) });
        }
    }

    gotoResult(result) {
        window.location = `${Redirects().request}/${result}`;
    }

    render() {
        if (this.state.validationError)
            console.log(this.state.validationError + " error");
        if (this.state.result)
            console.log(this.state.result.result);
        return (
            <form className="btn-block" onSubmit={this.handleSubmit}>
                <div class="card my-2" id="request-card">
                    <div class="card-body">
                        <a data-toggle="collapse" href="#collapseContent" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <div>
                                <h3 class="text-center">Request a quote</h3>
                            </div>
                        </a>
                        <div id="collapseContent" className="collapse">
                            <div class="form-group">
                                <input type="text" class="form-control quote-input-text" onChange={this.handleFname} value={this.state.fName} placeholder="First Name" required />
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control quote-input-text" onChange={this.handleLname} value={this.state.lName} placeholder="Last Name" required />
                            </div>

                            <div class="form-group">
                                <input type="email" class="form-control quote-input-text" onChange={this.handleEmail} value={this.state.email} placeholder="Email" required />
                            </div>

                            <div class="form-group">
                                <input type="text" class="form-control quote-input-text" onChange={this.handlePhone} value={this.state.phone} placeholder="Phone Number" />
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <textarea class="form-control quote-input-text" onChange={this.handleMsg} value={this.state.msg} placeholder="Message"></textarea>
                                    </div>
                                    <div id="requestValidationError">
                                        {this.state.validationError && this.state.validationError}
                                    </div>
                                    <div class="form-check">
                                        <input type="checkbox" onChange={this.handleCheck} checked={this.state.sendOffers} class="form-check-input" id="exampleCheck1" />
                                        <label class="form-check-label" for="exampleCheck1">Send info about new products & specials on similar items</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <input id="btn-submit" type="submit" value="Send Request" className="btn requestQuote btn-block" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

const BrochureButton = (props) => {
    const paths = GlobalContext().paths;
    return (
        <a href={paths.brochures + props.brochure} download className="btn btn-block drc-btn-brochure" >Download Brochure</a>
    )
}

const VideoBtn = (props) => {

    let video = null;
    switch (props.id) {
        case "Vwd7KUKRb2Xo":
            video = Vwd7KUKRb2Xo();
            break;
        case "V1k4t47qOaEM":
            video = V1k4t47qOaEM();
            break;
        case "VSmJWrc__T68":
            video = VSmJWrc__T68();
            break;
        case "VMwdi0A8hHO0":
            video = VMwdi0A8hHO0();
            break;
        case "VxUrTzGRYnFg":
            video = VxUrTzGRYnFg();
            break;
        case "Vz35ELHuxfkw":
            video = Vz35ELHuxfkw();
            break;
        case "V5gvSvFh6NF4":
            video = V5gvSvFh6NF4();
            break;
        case "VhBHiZ8TcQ7c":
            video = VhBHiZ8TcQ7c();
            break;
    }

    const paths = GlobalContext().paths;
    return (
        <div className="youtube-card">
            <a data-fancybox href={video.link}>
                <div className="youtube-card-imgframe">
                    <img class="youtube-thumb" src={paths.pictures + video.thumb} />
                    <img id="youtube-logo" className="youtube-video-logo" width="20%" src={paths.pictures + "youtube.svg"}></img>
                    <div className="youtube-thumb-overlay"></div>
                </div>
            </a>
            <p><strong> {video.description}</strong></p>
        </div>
    )
}

const WebpImagePreferRenderer = (props) => {
    const paths = GlobalContext().paths;

    let width = null;
    var style = { margin: "auto" };
    if (props.width) {
        switch (props.width) {
            case 25:
                width = "25%";
                break;
            case 35:
                width = "35%";
                break;
            case 50:
                width = "50%";
                break;
            case 75:
                width = "75%";
                break;
            case 100:
                width = "100%";
                break;
        }

        style = {
            width: width,
            height: "auto",
            margin: "auto",
        }
    }

    if (props.normal) {
        style.margin = null;
    }

    if (props.image.substring(props.image.length - 3, props.image.length) == "svg")
        return (
            <img style={style} title={props.title && props.title} src={paths.pictures + props.image} alt="..." className={props.cssClass} />
        )

    let iName = props.image.substring(0, props.image.length - 4);

    if (props.sm) {
        return (
            <picture>
                <source media="(max-width:991px)" type="image/webp" srcSet={paths.pictures + "/webp/sm-" + iName + ".webp"} />
                <source media="(min-width:992px)" type="image/webp" srcSet={paths.pictures + "/webp/" + iName + ".webp"} />
                <source media="(max-width:991px)" srcSet={paths.pictures + "sm-" + props.image} />
                <img media="(min-width:992px)" style={style} title={props.title && props.title} src={paths.pictures + props.image} alt="..." className={props.cssClass} />
            </picture>
        )
    }

    return (
        <picture>
            <source type="image/webp" srcSet={paths.pictures + "/webp/" + iName + ".webp"} />
            <img style={style} title={props.title && props.title} src={paths.pictures + props.image} alt="..." className={props.cssClass} />
        </picture>
    )
}

export const ImgRender = WebpImagePreferRenderer;// Imger;
export const VideoButton = VideoBtn;
export const BrochureBtn = BrochureButton;
export default QuoteRequestForm;

const Vz35ELHuxfkw = () => {
    let obj = {
        id: "z35ELHuxfkw",
        description: "CANON DOCUMENT SCANNING WITH UNIFLOW SOFTWARE",
        link: "https://www.youtube.com/watch?v=z35ELHuxfkw",
        thumb: "yt-uniflow1.jpg"
    }

    return obj;
}

const V5gvSvFh6NF4 = () => {
    let obj = {
        id: "5gvSvFh6NF4",
        description: "CANON imageRUNNER ADVANCE COPIER/PRINTERS—PRODUCT DESIGN",
        link: "https://www.youtube.com/watch?v=5gvSvFh6NF4",
        thumb: "5gvSvFh6NF4.jpg"

    }

    return obj;
}

const VhBHiZ8TcQ7c = () => {
    let obj = {
        id: "hBHiZ8TcQ7c",
        description: "FireKing How its Made",
        link: "https://www.youtube.com/watch?v=hBHiZ8TcQ7c",
        thumb: "hBHiZ8TcQ7c.jpg"

    }



    return obj;
}

const VxUrTzGRYnFg = () => {
    let obj = {
        id: "xUrTzGRYnFg",
        description: "CANON SCANNING SOFTWARE UNIFLOW CONTROL ACCESS & CONTROL COST",
        link: "https://www.youtube.com/watch?v=xUrTzGRYnFg",
        thumb: "yt-uniflow2.jpg"
    }

    return obj;
}

const VMwdi0A8hHO0 = () => {
    let obj = {
        id: "Mwdi0A8hHO0",
        description: "CANON imageRUNNER ADVANCE C5500 SERIES--OVERVIEW",
        link: "https://www.youtube.com/watch?v=Mwdi0A8hHO0",
        thumb: "yt-ir5500.jpg"
    }

    return obj;
}

const VSmJWrc__T68 = () => {
    let obj = {
        id: "SmJWrc__T68",
        description: "CANON imageRUNNER C3500 SERIES—OVERVIEW",
        link: "https://www.youtube.com/watch?v=SmJWrc__T68",
        thumb: "yt-ir3500.jpg"
    }

    return obj;
}

const V1k4t47qOaEM = () => {
    let obj = {
        id: "1k4t47qOaEM",
        description: "CANON WIDE FORMAT imagePROGRAF PRO SERIES",
        link: "https://www.youtube.com/watch?v=1k4t47qOaEM",
        thumb: "yt-ipfpro.jpg"

    }

    return obj;
}

const Vwd7KUKRb2Xo = () => {
    let obj = {
        id: "wd7KUKRb2Xo",
        description: "COPY PAPER NAVIGATOR BRAND",
        link: "https://www.youtube.com/watch?v=wd7KUKRb2Xo",
        thumb: "yt-navigator.jpg"
    }

    return obj;
}